// mantine
import { Group, Box } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const PreviewHeader = () => {
  const isDesktop = useMediaQuery('(min-width: 56.25em)');

  return (
    <Group justify="space-between" h="100%" w="100%" px="md" wrap="nowrap">
      {/* Desktop logo */}
      {isDesktop ? (
        <Box component="span" style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src="https://driptours.com/wp-content/themes/picostrap5-child-base/assets/images/DT-logo.png"
            alt="Logo"
            style={{ maxWidth: '100%', height: 'auto', maxHeight: 48, paddingTop: 4 }}
          />
        </Box>
      ) : (
        /* Mobile logo */
        <Box
          component="img"
          src="https://driptours.com/wp-content/themes/picostrap5-child-base/assets/images/DT-logo.png"
          alt="Logo"
          style={{ maxWidth: 200, height: 'auto' }}
        />
      )}

      {/* Spacer */}
      <Box style={{ flexGrow: 1 }} />

      {/* Right section placeholder for future items */}
      <Group gap="sm" />
    </Group>
  );
};

export default PreviewHeader;
